import { Container, Grid } from '@material-ui/core';
import React from 'react';

import Header from '../../components/header/Header';
import { projects } from "../../portfolio";
import { useLocalStorage } from '../../hooks/useLocalStorage';
import { StyleProvider } from '../../contexts/StyleContext';
import Top from '../../containers/topbutton/Top';
import ProjectCard from './ProjectCard';



const Projects = () => {
    const darkPref = window.matchMedia("(prefers-color-scheme: dark)");
    const [isDark, setIsDark] = useLocalStorage("isDark", darkPref.matches);
    // const history = useHistory();

    // const handleClick = (id) => {
    //     history.push(`/project/${id}`)
    // };

    const changeTheme = () => {
        setIsDark(!isDark);
    };
    return (
        <div className={isDark ? "dark-mode" : null} style={{ paddingBottom: 50 }}>
            <StyleProvider value={{ isDark: isDark, changeTheme: changeTheme }}>
                <Header outside />
                <Container maxWidth="lg" >
                    <h1 className="skills-heading" style={{ marginTop: 70 }}>{projects.titleAll}</h1>
                    <Grid container spacing={2} >
                        {
                            projects.projects.map(project => <Grid item xs={12} sm={6} md={4} key={project._id}>
                                <ProjectCard isDark={isDark} project={project} />
                            </Grid>)
                        }

                    </Grid>
                </Container>
                <Top />
            </StyleProvider >
        </div >

    );
};

export default Projects;

